import {
  ComponentRef,
  ElementRef,
  EnvironmentInjector,
  Injectable,
  Injector,
  NgModuleRef,
  ViewContainerRef,
  inject,
  runInInjectionContext,
} from '@angular/core';
import {Observable} from 'rxjs';
import {CmsComponentMapping} from '@spartacus/core';
import {DefaultComponentHandler} from '@spartacus/storefront';

/**
 * Fixes NG0919 thrown by DefaultComponentHandler.launcher() in Spartacus ≤221121.18.0.
 *
 * Root cause: the base class calls viewContainerRef.createComponent() inside a plain
 * Observable subscriber, outside any Angular injection context. Component constructors
 * that call inject() (directly or via dependencies) throw NG0919.
 *
 * Fix: wrap the createComponent call with runInInjectionContext, and use the modern
 * class-based createComponent API (avoids deprecated ComponentFactoryResolver).
 * This also fixes LazyComponentHandler, which delegates to DefaultComponentHandler by token.
 *
 * Remove this override once Spartacus ships an upstream fix.
 */
@Injectable({providedIn: 'root'})
export class DcpDefaultComponentHandler extends DefaultComponentHandler {
  private readonly environmentInjector = inject(EnvironmentInjector);

  override launcher(
    componentMapping: CmsComponentMapping,
    viewContainerRef: ViewContainerRef,
    elementInjector?: Injector,
    module?: NgModuleRef<any>,
  ): Observable<{elementRef: ElementRef; componentRef?: ComponentRef<any>}> {
    return new Observable((subscriber) => {
      const componentRef = runInInjectionContext(this.environmentInjector, () =>
        viewContainerRef.createComponent(componentMapping.component, {
          injector: elementInjector ?? viewContainerRef.injector,
          ngModuleRef: module,
        }),
      );

      subscriber.next({elementRef: componentRef.location, componentRef});

      return () => componentRef.destroy();
    });
  }
}
